var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"patent-spec"},[(_setup.descriptionData)?_c('div',{staticClass:"description-content",domProps:{"innerHTML":_vm._s(_setup.formattedDescription)}}):_c('el-empty',{attrs:{"description":"暂无说明书数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }